import { ReactNode } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./constants";
import { AddCartNonMatchingProductFormValues } from "./types";

interface Props {
  children?: ReactNode;
  defaultFormValues?: Partial<AddCartNonMatchingProductFormValues>;
}

export const AddCartNonMatchingProductFormProvider = ({
  children,
  defaultFormValues = {},
}: Props) => {
  const methods = useForm<AddCartNonMatchingProductFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: defaultFormValues,
    resolver: yupResolver(schema),
  });

  /*
  const fieldsToRegister: (keyof AddCartNonMatchingProductFormValues)[] = [
    "name",
    "barcode",
    "price",
    "quantity",
  ];

  fieldsToRegister.forEach((t) => methods.register(t));
  */

  return <FormProvider {...methods}>{children}</FormProvider>;
};
